import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined';

export default function AccessModal({ open, message, onClose }) {

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          padding: 3,
          background: 'linear-gradient(to bottom, #ffffff, #fef2f2)',
        },
      }}
    >
      <DialogContent sx={{ textAlign: 'center', paddingTop: 2 }}>
        {/* Icon Container */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 3,
          }}
        >
          <Box
            sx={{
              width: 100,
              height: 100,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 8px 16px rgba(220, 38, 38, 0.2)',
            }}
          >
            <GppBadOutlinedIcon sx={{ fontSize: 50, color: '#dc2626' }} />
          </Box>
        </Box>

        {/* Title */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: '#1f2937',
            marginBottom: 2,
          }}
        >
          Login Failed
        </Typography>

        {/* Message */}
        <Typography
          variant="body1"
          sx={{
            color: '#6b7280',
            lineHeight: 1.8,
            fontSize: '1rem',
            marginBottom: 3,
          }}
        >
          {message}
        </Typography>

        {/* Support Contact Box */}
          <Box
            sx={{
              backgroundColor: '#f3f4f6',
              borderRadius: 2,
              padding: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              marginBottom: 2,
            }}
          >
            <MailOutlineIcon sx={{ fontSize: 20, color: '#6b7280' }} />
            <Typography
              variant="body2"
              sx={{
                color: '#4b5563',
                fontSize: '0.95rem',
              }}
            >
              Need help?{' '}
              <a
                href="mailto:support@cibermed.com"
                style={{
                  color: '#dc2626',
                  textDecoration: 'none',
                  fontWeight: 600,
                }}
              >
                support@cibermed.com
              </a>
            </Typography>
          </Box>
      </DialogContent>

      {/* Action Button */}
      <DialogActions sx={{ paddingX: 3, paddingBottom: 2 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: '#dc2626',
            color: 'white',
            padding: '14px',
            fontSize: '1rem',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 2.5,
            boxShadow: '0 4px 12px rgba(220, 38, 38, 0.3)',
            '&:hover': {
              backgroundColor: '#b91c1c',
              boxShadow: '0 6px 16px rgba(220, 38, 38, 0.4)',
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}